const RATING_COPY = {
  cqc: {
    outstanding: "Outstanding",
    good: "Good",
    requires_improvement: "Requires improvement",
    inadequate: "Inadequate",
    not_published: "Rating not published",
    null: "Registered, awaiting routine inspection",
  },
  ci: {
    excellent: "Excellent",
    very_good: "Very good",
    good: "Good",
    adequate: "Adequate",
    weak: "Weak",
    unsatisfactory: "Unsatisfactory",
    not_published: "Rating not published",
    null: "Not yet rated",
  },
}

export default function useRatingCopy(regulator, rating) {
  return RATING_COPY?.[regulator]?.[rating] || "Not yet rated"
}
